import { defineMessages } from "react-intl";

export const scope = "form_builder";

export default defineMessages({
  usedForAds: {
    id: `${scope}.ads.used_for_ads`,
    defaultMessage: "Used for Ads",
  },
  adCampaignName: {
    id: `${scope}.ads.ad_campaign_name`,
    defaultMessage: "Campaign name",
  },
  adCampaignNamePlaceholder: {
    id: `${scope}.ads.ad_campaign_name.placeholder`,
    defaultMessage: "Shown on Ads pipeline cards (defaults to the form name)",
  },
  preventBots: {
    id: `${scope}.settings.prevent_bots`,
    defaultMessage: "Prevent Bots",
  },
  mediumColumnTitle: {
    id: `${scope}.ads.table.medium`,
    defaultMessage: "Medium",
  },
  adsListHeaderTitle: {
    id: `${scope}.ads.title.header`,
    defaultMessage: "Ad Contacts",
  },
  adsTableContactName: {
    id: `${scope}.ads.table.contact_name`,
    defaultMessage: "Contact Name",
  },
  adsTableCreatedAt: {
    id: `${scope}.ads.table.created_at`,
    defaultMessage: "Created At",
  },
  adsTableSource: {
    id: `${scope}.ads.table.source`,
    defaultMessage: "Source",
  },
  adsTableFormName: {
    id: `${scope}.ads.table.form_name`,
    defaultMessage: "Form Name",
  },
  adsTableTrackingParam: {
    id: `${scope}.ads.table.tracking_param`,
    defaultMessage: "Tracking Param",
  },
  adsTableCopied: {
    id: `${scope}.ads.table.copied`,
    defaultMessage: "Copied!",
  },
  adsFilterSourcePlaceholder: {
    id: `${scope}.ads.filter.source.placeholder`,
    defaultMessage: "All Sources",
  },
  adsDateRangeToday: {
    id: `${scope}.ads.date_range.today`,
    defaultMessage: "Today",
  },
  adsDateRangeThisWeek: {
    id: `${scope}.ads.date_range.this_week`,
    defaultMessage: "This Week",
  },
  adsDateRangeLastWeek: {
    id: `${scope}.ads.date_range.last_week`,
    defaultMessage: "Last Week",
  },
  adsDateRangeThisMonth: {
    id: `${scope}.ads.date_range.this_month`,
    defaultMessage: "This Month",
  },
  adsDateRangeLastMonth: {
    id: `${scope}.ads.date_range.last_month`,
    defaultMessage: "Last Month",
  },
  adsDateRangeThisYear: {
    id: `${scope}.ads.date_range.this_year`,
    defaultMessage: "This Year",
  },
  adsDateRangeLastYear: {
    id: `${scope}.ads.date_range.last_year`,
    defaultMessage: "Last Year",
  },
  adsDownloadButton: {
    id: `${scope}.ads.download.button`,
    defaultMessage: "Download",
  },
  adsDownloadTooltip: {
    id: `${scope}.ads.download.tooltip`,
    defaultMessage: "Download ad sources as CSV",
  },
  formBuilderHeaderTitle: {
    id: `${scope}.title.header`,
    defaultMessage: "Form Builder",
  },
  formListHeaderTitle: {
    id: `${scope}.builder.title.header`,
    defaultMessage: "Forms",
  },
  searchText: {
    id: `${scope}.table.search.placeholder`,
    defaultMessage: "Search...",
  },
  editForm: {
    id: `${scope}.table.button.edit_form`,
    defaultMessage: "Edit",
  },
  copyForm: {
    id: `${scope}.table.button.copy_form`,
    defaultMessage: "Copy",
  },
  deleteForm: {
    id: `${scope}.table.button.delete_form`,
    defaultMessage: "Delete",
  },
  renameForm: {
    id: `${scope}.table.button.rename_form`,
    defaultMessage: "Rename",
  },
  name: {
    id: `${scope}.table.header.name`,
    defaultMessage: "Name",
  },
  formID: {
    id: `${scope}.table.header.form_id`,
    defaultMessage: "Form ID",
  },
  status: {
    id: `${scope}.table.header.status`,
    defaultMessage: "Status",
  },
  campaign: {
    id: `${scope}.table.header.campaign`,
    defaultMessage: "Campaign",
  },
  campaignLabel: {
    id: `${scope}.modal.campaignLabel`,
    defaultMessage: "Select Campaign (You'll see only Published ones)",
  },
  campaignsInfo: {
    id: `${scope}.modal.campaignsInfo`,
    defaultMessage:
      "If a form has a campaign, it cannot be used on landing page.",
  },
  newFormButton: {
    id: `${scope}.button.new_form_button`,
    defaultMessage: "New Form",
  },

  newFormNameLabel: {
    id: `${scope}.new_form.label.name`,
    defaultMessage: "Name",
  },
  emptyFieldError: {
    id: `${scope}.new_form.error.empty_field`,
    defaultMessage: "Name is required",
  },
  nameLengthConstraint: {
    id: `${scope}.new_form.error.max_length`,
    defaultMessage: "Ensure this field has no more than 255 characters",
  },
  confirmButton: {
    id: `${scope}.new_form.button.confirm`,
    defaultMessage: "Save",
  },
  cancelButton: {
    id: `${scope}.new_form.button.cancel`,
    defaultMessage: "Cancel",
  },
  copyButton: {
    id: `${scope}.modal.button.copy`,
    defaultMessage: "Copy",
  },
  copyTitle: {
    id: `${scope}.modal.title.copy`,
    defaultMessage: "Copy Form",
  },
  renameTitle: {
    id: `${scope}.modal.title.rename`,
    defaultMessage: "Rename Form",
  },
  renameButton: {
    id: `${scope}.modal.button.rename`,
    defaultMessage: "Rename",
  },
  deleteButton: {
    id: `${scope}.modal.button.delete`,
    defaultMessage: "Delete",
  },
  deleteTitle: {
    id: `${scope}.modal.title.delete`,
    defaultMessage: "Confirmation",
  },
  deleteDescription: {
    id: `${scope}.modal.description.delete`,
    defaultMessage: "Are you sure you want to delete this form?",
  },
  nameAlreadyExists: {
    id: `${scope}.builder.error.name_already_exists`,
    defaultMessage: "Form with that name already exists",
  },
  createSuccessful: {
    id: `${scope}.builder.success.create`,
    defaultMessage: "Form created!",
  },
  updateSuccessful: {
    id: `${scope}.builder.success.update`,
    defaultMessage: "Form updated!",
  },
  deleteSuccessful: {
    id: `${scope}.builder.success.delete`,
    defaultMessage: "Form deleted!",
  },
  copySuccessful: {
    id: `${scope}.builder.success.copy`,
    defaultMessage: "Form copied!",
  },
  renameSuccessful: {
    id: `${scope}.builder.success.rename`,
    defaultMessage: "Form renamed!",
  },
  saveFormlabel: {
    id: `${scope}.builder.form.label.save_form`,
    defaultMessage: "Save Form",
  },
  integrateFormText: {
    id: `${scope}.builder.form.integrate_form`,
    defaultMessage: "Integrate Form",
  },
  integrateTextDescription: {
    id: `${scope}.builder.form.description`,
    defaultMessage:
      "Use the following options to integrate your custom { embedItem } into your website",
  },
  iframeText: {
    id: `${scope}.builder.form.iframe`,
    defaultMessage: "Embed code",
  },
  customCssLabel: {
    id: `${scope}.custom_css.label`,
    defaultMessage: "Custom CSS",
  },
  customCssHelp: {
    id: `${scope}.custom_css.help`,
    defaultMessage:
      "CSS entered here is applied to the embedded form. Use it to match your site's styling — target the form's classes/elements. It overrides the form's default styles.",
  },
  customCssPlaceholder: {
    id: `${scope}.custom_css.placeholder`,
    defaultMessage: ".aeva-form input { border-radius: 8px; }",
  },
  embedTab: {
    id: `${scope}.embed_modal.tab.embed`,
    defaultMessage: "Embed",
  },
  linkTab: {
    id: `${scope}.embed_modal.tab.link`,
    defaultMessage: "Link",
  },
  iframeCopyText: {
    id: `${scope}.builder.form.iframe.copy`,
    defaultMessage:
      "Copy the link below and easily share it anywhere you wish.",
  },
  formText: {
    id: `${scope}.form.text`,
    defaultMessage: "Form",
  },
  afterSubmitActionLabel: {
    id: `${scope}.after_submit_action.label`,
    defaultMessage: "After form submit:",
  },
  redirectActionLabel: {
    id: `${scope}.redirect.label`,
    defaultMessage: "Redirect to page",
  },
  showThankYouMessageActionLabel: {
    id: `${scope}.show_thank_you_message.label`,
    defaultMessage: "Show thank you message",
  },
  redirectLabel: {
    id: `${scope}.redirect.label`,
    defaultMessage: "After form submit redirect to page:",
  },
  redirectPlaceholder: {
    id: `${scope}.redirect.placeholder`,
    defaultMessage: "URL",
  },
  submitMessageLabel: {
    id: `${scope}.message.label`,
    defaultMessage: "Edit thank you message:",
  },
  submitMessagePlaceholder: {
    id: `${scope}.message.placeholder`,
    defaultMessage: "Thank you for submiting your data!",
  },
  toggleBtnRequiredText: {
    id: `${scope}.toggleBtnRequired.text`,
    defaultMessage: "required",
  },
  toggleBtnNotRequiredText: {
    id: `${scope}.toggleBtnNotRequired.text`,
    defaultMessage: "not required",
  },
  toggleBtnLabel: {
    id: `${scope}.toggleBtnLabel.text`,
    defaultMessage: "Phone is:",
  },
  formTab: {
    id: `${scope}.formTab.text`,
    defaultMessage: "Form",
  },
  fieldsTab: {
    id: `${scope}.fieldsTab.text`,
    defaultMessage: "Fields",
  },
  builderTab: {
    id: `${scope}.builderTab.text`,
    defaultMessage: "Builder",
  },
  styles: {
    id: `${scope}.styles.title`,
    defaultMessage: "Styles",
  },
  presetStyle: {
    id: `${scope}.presetStyle.title`,
    defaultMessage: "Preset Style",
  },
  presetStyleDefault: {
    id: `${scope}.presetStyle.default`,
    defaultMessage: "Default",
  },
  presetStyleLine: {
    id: `${scope}.presetStyle.line`,
    defaultMessage: "Line",
  },
  presetStyleBox: {
    id: `${scope}.presetStyle.box`,
    defaultMessage: "Box",
  },
  labelConfig: {
    id: `${scope}.label.title`,
    defaultMessage: "Label",
  },
  labelInclude: {
    id: `${scope}.label.include`,
    defaultMessage: "Include",
  },
  labelExclude: {
    id: `${scope}.label.exclude`,
    defaultMessage: "Exclude",
  },
  fieldsTabTooltip: {
    id: `${scope}.fieldsTab.tooltip`,
    defaultMessage: "Fields tab is disabled until you click on the canvas.",
  },
  editThankYouMessageButton: {
    id: `${scope}.edit_thank_you_message_button`,
    defaultMessage: "Edit Thank You Message",
  },
  adsTableAmountSpent: {
    id: `${scope}.ads.table.amount_spent`,
    defaultMessage: "Amount Spent",
  },
  adsTransactionsDrawerTitle: {
    id: `${scope}.ads.transactions_drawer.title`,
    defaultMessage: "Transactions",
  },
  tipAmountColumn: {
    id: `${scope}.ads.table.tip_amount`,
    defaultMessage: "Tip",
  },
  taxAmountColumn: {
    id: `${scope}.ads.table.tax_amount`,
    defaultMessage: "Tax",
  },
  amountColumn: {
    id: `${scope}.ads.table.amount`,
    defaultMessage: "Amount",
  },
  paymentTypeColumn: {
    id: `${scope}.ads.table.payment_type`,
    defaultMessage: "Payment Type",
  },
  dateColumn: {
    id: `${scope}.ads.table.date`,
    defaultMessage: "Date",
  },
  adsTableDeleteAction: {
    id: `${scope}.ads.table.action.delete`,
    defaultMessage: "Delete",
  },
  adsDeleteConfirmTitle: {
    id: `${scope}.ads.delete.confirm.title`,
    defaultMessage: "Confirmation",
  },
  adsDeleteConfirmDescription: {
    id: `${scope}.ads.delete.confirm.description`,
    defaultMessage: "Are you sure you want to delete this ad source?",
  },
  adsDeleteSuccessful: {
    id: `${scope}.ads.delete.success`,
    defaultMessage: "Ad source deleted!",
  },
});
